import React, { Component } from 'react';
import Slider from 'react-slick';
import Constants from '../../Constants';
import BrowserFeatures from '../../utils/BrowserFeatures';
import EirButton from '../eir-button/EirButton';
import Dom from '../../utils/Dom'
import { Container, Row, Col } from 'reactstrap';
import Subtitle from '../subtitle/Subtitle';
import Title from '../title/Title';


function ArrowRight(props) {
  const { onClick } = props;
  return (
    <EirButton
      text=''
      type='link'
      icon='arrowright-white'
      className='arrowRight'
      onClick={onClick}
    />
  );
}

function ArrowLeft(props) {
  const { onClick } = props;
  return (
    <EirButton
      text=''
      type='link'
      icon='arrowleft-white'
      className='arrowLeft'
      onClick={onClick}
    />
  );
}

class GeneralCarousel extends Component {
  constructor(props) {
    super(props);
    Dom.addStyleSheet(Constants.externalCss.slickCarousel.minified);
    Dom.addStyleSheet(Constants.externalCss.slickCarousel.themeMinified);

    this.state = {
      settings: {
        infinite: false,
        dots: true,
        speed: 500,
        focusOnSelect: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        centerMode: true,
        respondTo: 'window',
        className: 'mx-auto',
        variableWidth: true,
        centerPadding: '0',
        initialSlide: 0,
        beforeChange: (current, next) =>
          this.setState({ oldSlide: current, activeSlide: next }),
        afterChange: current => this.setState({ activeSlide2: current })
      }
    }
  }

  componentDidMount() {
    this.toggleArrows();
    this.setState({ oldSlide: 0, activeSlide: 0 })
  }

  toggleArrows() {
    if (BrowserFeatures.hasTouch()) {
      this.setState({ settings: { ...this.state.settings, ...{ 'arrows': false } } });
    }
    else {
      const settings = { 'nextArrow': <ArrowRight />, 'prevArrow': <ArrowLeft /> };
      this.setState({ settings: { ...this.state.settings, ...settings } });
    }
  }

  render() {

    //console.log("STATE")
    //console.log(this.state)

    const slides = this.props.items.map((item) =>
      <div className="eir-slide">
        <img src={item.src} />
      </div>
    );

    //console.log("SLIDES")
    //console.log(slides)

    return (
      <Container>
        <div className="flex-nowrap">
          <Slider {...this.state.settings}>
            {slides}
          </Slider>
        </div>
        
        {this.props.textHeading &&
          <div className="h2 eir-title">{this.props.textHeading[this.state.activeSlide]}
          </div>
        }

        
        <div className="justify-content-center">
          <Subtitle text={this.props.optionalText[this.state.activeSlide]} />
        </div>
      </Container>


    );
  }



}
export default GeneralCarousel;
